import AudienceTypeChip from '@/components/mediaBuying/adCampaign/AudienceTypeChip'
import TargetingOptionList from '@/components/mediaBuying/adCampaign/TargetingOptionList'
import { SUGGESTIONS_NOTE, getHypothesisMap, isSuggestedAudienceKind } from '@/utils/audience-builder'
import { getLookalikeMap } from '@/utils/lookalike-audiences'

export const ADVANTAGE_AGE_NOTE =
    'Used as suggestions; Meta may show ads outside these ranges. Minimum age stays fixed.'

export const FIXED_AUDIENCE_NOTE = 'The audience is set when the ad set is created and cannot be changed here.'

/**
 * Explains an AI audience or a lookalike in the targeting settings: what it is, that its interests are fixed,
 * and for Advantage+ audiences that age and gender choices (and persona interests) are only suggestions.
 */
const HypothesisAudienceNotice = ({ audienceId, getStepContentData }) => {
    const salesFunnelData = getStepContentData('salesFunnelSetup')
    const hypothesis = getHypothesisMap(salesFunnelData)[audienceId] || getLookalikeMap(salesFunnelData)[audienceId]
    if (!hypothesis) return null

    const isEditing = getStepContentData('prefetchedData')?.isEditMode === true
    const interests = hypothesis.interests || []
    const targetingOptions = hypothesis.targetingOptions || []
    const suggested = isSuggestedAudienceKind(hypothesis.kind)

    return (
        <div
            className="tw:flex tw:flex-col tw:gap-2 tw:rounded-lg tw:bg-gray-500 tw:px-4 tw:py-3"
            data-testid="ai-audience-notice"
        >
            <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-2">
                <span className="tw:text-sm tw:font-semibold">{hypothesis.label}</span>
                <AudienceTypeChip kind={hypothesis.kind} />
            </div>
            {(isEditing || interests.length > 0 || targetingOptions.length > 0) && (
                <p className="tw:text-sm tw:text-gray-200">{FIXED_AUDIENCE_NOTE}</p>
            )}
            {interests.length > 0 && (
                <ul
                    className="tw:flex tw:flex-wrap tw:gap-1.5"
                    aria-label={suggested ? 'Suggested audience interests' : 'Audience interests'}
                >
                    {interests.map((interest) => (
                        <li key={interest.id} className="tw:rounded tw:bg-gray-400/40 tw:px-2 tw:py-0.5 tw:text-xs">
                            {interest.name}
                        </li>
                    ))}
                </ul>
            )}
            <TargetingOptionList
                options={targetingOptions}
                label={suggested ? 'Suggested behaviours and demographics' : 'Audience behaviours and demographics'}
            />
            {suggested && (
                <p className="tw:text-sm tw:text-gray-200" data-testid="suggestions-note">
                    {SUGGESTIONS_NOTE}
                </p>
            )}
            {hypothesis.audienceMode === 'advantage' && (
                <p className="tw:text-sm tw:text-gray-200" data-testid="advantage-age-note">
                    {ADVANTAGE_AGE_NOTE}
                </p>
            )}
        </div>
    )
}

export default HypothesisAudienceNotice
